import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BreedConditions, BreedGroupDetails, BreedTestimonialsData } from '@constants/breed-personalization';
import { Breed } from '@models/Breed';
import { Observable } from 'rxjs';
import { AppEnvironment } from 'src/environments/AppEnvironment';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: `root` })
export class BreedService {
	constructor(private readonly http: HttpClient) { }

	// List of all breeds
	getAllBreeds(): Observable<Breed[]> {
		const breedsJson: string = `https://epiassets.azureedge.net/assets
			${[AppEnvironment.DEV, AppEnvironment.RC, AppEnvironment.LOCAL].includes(environment.appEnvironment) ? '-dev' : ''}
			/breeds/breeds.json`;

		return this.http.get<Breed[]>(breedsJson);
	}

	// List of breed group details and their conditions
	getBreedGroupDetails(): Observable<{
		breedGroupDetails: BreedGroupDetails;
		conditions: BreedConditions;
	}> {
		const dogBreedGroupDetails: string = `https://epiassets.azureedge.net/assets` +
			`${[AppEnvironment.DEV, AppEnvironment.RC, AppEnvironment.LOCAL].includes(environment.appEnvironment) ? '-dev' : ''}` +
			`/breeds/breedGroupDetails.json`;

		return this.http.get<{
			breedGroupDetails: BreedGroupDetails;
			conditions: BreedConditions;
		}>(dogBreedGroupDetails);
	}

	getBreedTestimonials(): Observable<BreedTestimonialsData> {
		const breedTestimonials: string = `https://epiassets.azureedge.net/assets` +
			`${[AppEnvironment.DEV, AppEnvironment.RC, AppEnvironment.LOCAL].includes(environment.appEnvironment) ? '-dev' : ''}` +
			`/breeds/breedTestimonials.json`;

		return this.http.get<BreedTestimonialsData>(breedTestimonials);
	}
}
